import { theme } from 'aimo-ui';
import SearchInputBottomSheet from 'components/SearchInput/SearchInputBottomSheet';
import Sheet from 'components/sheets/Sheet';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Keyboard } from 'react-native';
import { useCityParkingStore } from 'stores/cityParkingStore';
import styled from 'styled-components/native';
import CityParkingListSearch from './CityParkingListSearch';

const Wrapper = styled.Pressable`
  padding: 0 20px;
  height: 100%;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-bottom: 25px;
  flex: 1;
`;

const pressHandler = () => {
  Keyboard.dismiss();
};

const CityParkingSearchSheet: React.FC<{
  isTesting?: boolean;
}> = ({ isTesting = false }) => {
  const snappingPoints = ['50%', '85%'];
  const { t } = useTranslation();

  const searchTerm = useCityParkingStore(state => state.searchTerm);
  const setSearchTerm = useCityParkingStore(
    (state) => state.setSearchTerm
  )

  return (
    <Sheet snappingPoints={snappingPoints} bgColor={theme.colors.white}>
      <Wrapper
        onPress={pressHandler}
        accessible
        testID="street-parking-search-list">
        <SearchInputBottomSheet
          placeholder={t('search.streetWithNumber')}
          testID="city-pmcs-search-input"
          value={searchTerm}
          onChangeText={setSearchTerm}
          isTesting={isTesting}
        />
        <CityParkingListSearch testID="city-pmcs-search-list" />
      </Wrapper>
    </Sheet>
  );
};

export default CityParkingSearchSheet;
